import { TablePagination, useMediaQuery } from '@mui/material';

export function CustomTablePagination({ numTotalItems, rowsPerPage, page, setPage, setRowsPerPage }) {
  const isSmallScreen = useMediaQuery(theme => theme.breakpoints.down("sm"));

  return (
    <TablePagination
      showLastButton
      showFirstButton
      rowsPerPageOptions={[2, 5, 10, 20, 50, 100]}
      count={numTotalItems}
      rowsPerPage={rowsPerPage}
      page={page}
      onPageChange={(event, newPage) => setPage(newPage)}
      onRowsPerPageChange={(event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
      }}
      labelRowsPerPage={!isSmallScreen ? 'Linhas por página:' : false}
      labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count !== -1 ? count : `mais de ${to}`}`}
      component='div' // possibilita o alinhamento à direita
      sx={{ overflow: 'visible' }}
      getItemAriaLabel={(type, page, selected) => {
        if (type === 'first') {
          return 'Primeira página';
        }
        if (type === 'last') {
          return 'Última página';
        }
        if (type === 'next') {
          return 'Próxima página';
        }
        if (type === 'previous') {
          return 'Página anterior';
        }
        return `Página ${page + 1} ${selected ? 'selecionada' : ''}`;
      }}
    />
  )
}
